import { DatesRetriever, DatesGateway } from "../retriever";
import { internalMessageBus } from "sb-internal-msg-bus";
import { datesQueryFactory } from "../queries";
import { DatesParser } from "../parser";
import { Clock, MessageSender, MessageBus, State, ToggleTabEvent } from "../../../common";
import { GroupedSportsToDatesMapper } from "../mapper";
export const datesRetrieverFactory = (cms, dict, timeZoneObservable, bffGateway) => {
    const clock = new Clock(Date);
    const datesGateway = new DatesGateway(bffGateway, datesQueryFactory, new GroupedSportsToDatesMapper(dict), clock, cms.timeRange);
    const toggleTabEvent = new ToggleTabEvent(new MessageBus(internalMessageBus), cms.blockId);
    return new DatesRetriever(datesGateway, toggleTabEvent, clock, timeZoneObservable, cms.keepSelectedDay);
};
export const datesParserFactory = (cms, retriever) => {
    const messageSender = new MessageSender(new MessageBus(internalMessageBus), cms.blockId);
    return new DatesParser(retriever, messageSender);
};
export const datesStateFactory = (cms, domId) => {
    const messageSender = new MessageSender(new MessageBus(internalMessageBus), cms.blockId);
    return new State(messageSender, cms.blockId, domId);
};
//# sourceMappingURL=factories.js.map